<template>
  <v-tooltip :text="getFeedNameFromFeedType(service)">
    <template v-slot:activator="{ props }">
      <div v-bind="props" class="service-logo" @click="onClick">
        <img
          src="/assets/service-logos/google-search-console.png"
          :width="size"
          :style="`border-radius: ${size}; cursor: pointer`"
          v-if="service === IApp.IFeedTypes.GoogleSearchConsole"
        />
        <div
          :style="`border-radius: ${size}; width: ${size}; height: ${size}; `"
          v-if="service === IApp.IFeedTypes.GoogleAnalytics"
          class="service-logo__google-analytics"
        >
          <img src="/assets/service-logos/google-analytics.png" />
        </div>
        <img
          src="/assets/service-logos/bird-eye.png"
          :width="size"
          :style="`border-radius: ${size}; cursor: pointer`"
          v-if="service === IApp.IFeedTypes.BirdEye"
        />
      </div>
    </template>
  </v-tooltip>
</template>
<script setup lang="ts">
import { IApp } from "@/types";
import { getFeedNameFromFeedType } from "@/utils";

const { size, service, onClick } = defineProps<{
  size: string;
  service: IApp.IFeedTypes;
  onClick?: () => void;
}>();
</script>

<style scoped>
.service-logo {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.service-logo__google-analytics {
  background-color: white;
  cursor: pointer;
  padding: 1px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.service-logo__google-analytics img {
  width: 100%;
}
</style>
